// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing029({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/029/20241216_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/029/20241213_02.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/029/20241213_03.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/014/241118_04.jpg`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      eventDates={true}
    />
  );
}

export default Randing029;
